import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeHalIncotermsList } from './normalize';

export const fetchHalIncotermsList = createProvider(api.fetchHalIncotermsList)
  .andThen((res) => normalizeHalIncotermsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
